module.exports = __webpack_public_path__ + "static/media/hospital-clinical-management-system-dashboard.92a4f565.webp";